<!--
 * @Description: 用一句话描述文件的作用
 * @Author: Hlc
 * @Date: 2023-04-23 05:10:00
 * @LastEditors: Hlc
 * @LastEditTime: 2023-04-25 12:06:31
-->
<template>
  <div class="equipaddMain common-form-content">
    <el-form
        :model="formData"
        ref="form"
        :rules="rules"
        :inline="true"
        :show-message="false"
        size="normal"
    >
      <div class="form-content" style="margin-bottom: 0.3rem;">
        <el-form-item label="充电桩编码" prop="id">
          <el-input
              v-model="formData.id"
              placeholder="请输入"
              size="normal"
              clearable
              type="number"
              :disabled="editMode"
              @input="
              formData.id > 14
                ? (formData.id = formData.id.slice(0, 14))
                : formData.id
            "
              @blur="detectionIdFun"
          ></el-input>
        </el-form-item>
        <el-form-item label="充电桩名称" prop="pkname">
          <el-input
              v-model="formData.pkname"
              placeholder="请输入"
              size="normal"
              clearable
              maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item class="radio-group" label="充电桩类型" prop="pileType">
          <el-radio-group v-model="formData.pileType">
            <el-radio v-for="(item,index) in typeList" :key="`radio-group_${index}`" :label="item.label + ''">{{
                item.value
              }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="端口数量" prop="portCount">
          <el-input
              v-model="formData.portCount"
              placeholder="请输入"
              size="normal"
              clearable
              maxlength="10"
              :disabled="editMode"
          ></el-input>
        </el-form-item>
        <el-form-item label="电流（A）" prop="electricity">
          <el-input
              v-model="formData.electricity"
              placeholder="请输入"
              size="normal"
              clearable
              type="number"
              @input="
              formData.electricity > 5
                ? (formData.electricity = formData.electricity.slice(0, 5))
                : formData.electricity
            "
          ></el-input>
        </el-form-item>
        <el-form-item label="电压（V）" prop="voltage">
          <el-input
              v-model="formData.voltage"
              placeholder="请输入"
              size="normal"
              clearable
              type="number"
              @input="
              formData.voltage > 5
                ? (formData.voltage = formData.voltage.slice(0, 5))
                : formData.voltage
            "
          ></el-input>
        </el-form-item>
        <el-form-item label="功率（kW）" prop="maxPower">
          <el-input
              v-model="formData.maxPower"
              placeholder="请输入"
              size="normal"
              type="number"
              clearable
              @input="
              formData.maxPower > 5
                ? (formData.maxPower = formData.maxPower.slice(0, 5))
                : formData.maxPower
            "
          ></el-input>
        </el-form-item>
      </div>
      <div class="form-content">
        <el-form-item label="sim卡序列号" prop="simCard">
          <el-input
              v-model="formData.simCard"
              placeholder="请输入"
              size="normal"
              clearable
              maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item class="sim-due-time" label="sim卡到期时间" prop="simDueTime">
          <el-select
              v-model="simDueTime"
              placeholder="请选择"
              @focus="Select('date')"
              style="width: 100%;"
          >
          </el-select>
        </el-form-item>
      </div>
      <div class="form-content">
        <el-form-item class="radio-group" label="状态" prop="pileType">
          <el-radio-group v-model="formData.pileStatus">
            <el-radio v-for="(item,index) in stateList" :key="`radio-group_${index}`" :label="item.label + ''">{{
                item.value
              }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
      <div class="form-content">
        <el-form-item label="站点" prop="plot">
          <el-select
              v-model="xiaoquName"
              placeholder="请选择"
              @focus="Select('plot')"
              style="width: 100%;"
          >
          </el-select>
        </el-form-item>
      </div>
      <div class="form-content">
        <el-form-item label="代理商" prop="userId">
          <el-select
              v-model="userName"
              placeholder="请选择代理商"
              class="cardSelect"
              style="width: 100%"
              @focus="SelectOperator()"
          >
          </el-select>
        </el-form-item>
      </div>
      <div class="form-sub-box">
        <div class="submit-btn" :class="{'is-submit-state': mixin_submitBtnState}" @click="onSubmit">
          保存
        </div>
      </div>
    </el-form>
    <nut-picker
        :is-visible="showPicker"
        :list-data="activeList"
        @close="closeSwitch()"
        @confirm="confirm"
    ></nut-picker>
    <nut-datepicker
        :is-visible="simDateVisible"
        type="datetime"
        title="请选择时间日期"
        @close="switchPicker()"
        @choose="dateConfirm"
        startDate="2024-01-01 00:00"
        endDate="2030-10-05 10:04"
    >
    </nut-datepicker>
    <nut-picker
        :is-visible="showOperatorSelect"
        :list-data="operatorList"
        @close="closePicker"
        @confirm="confirmPicker"
    ></nut-picker>
  </div>
</template>
<script>
import {
  addEquip,
  getPlotList,
  getEquipList,
  editPile,
  getOperatorSelect,
} from "@/api/newApi";
import {Toast} from "vant";
import {validate} from "@/mixins/mixin";

export default {
  mixins: [validate],
  data() {
    var validateNum = (rule, value, callback) => {
      var reg = /^[0-9]+.?[0-9]*$/;
      if (value === "") {
        callback(new Error("请输入"));
      } else {
        if (!reg.test(value)) {
          callback(new Error("请输入正确的数值"));
        }
        callback();
      }
    };
    return {
      isAdmin: false,
      showOperatorSelect: false,
      operatorList: [],
      userName: "",
      formData: {
        portCount: 2,
        pileType: null,
        electricity: null,
        id: null,
        oldId:null,
        maxPower: null,
        pileStatus: null,
        pkname: null,
        plot: null,
        simCard: null,
        simDueTime: null,
        voltage: null,
        userId: null,
      },
      plotList: [],
      activeList: [],
      typeList: [
        {
          label: 0,
          value: "慢充",
        },
        {
          label: 1,
          value: "快充",
        },
      ],
      stateList: [
        {
          label: 0,
          value: "禁用",
        },
        {
          label: 1,
          value: "启用",
        },
      ],
      rules: {
        id: [
          {required: true, message: "请输入充电桩编号", trigger: "blur"},
          {min: 14, max: 14, message: "电桩编号限制14位数字", trigger: "blur"},
          {validator: validateNum, trigger: "blur"},
        ],
        electricity: [
          {required: true, message: "请输入电流", trigger: "blur"},
          {validator: validateNum, trigger: "blur"},
        ],
        voltage: [
          {required: true, message: "请输入电压", trigger: "blur"},
          {validator: validateNum, trigger: "blur"},
        ],
        maxPower: [
          {required: true, message: "请输入最大功率", trigger: "blur"},
          {validator: validateNum, trigger: "blur"},
        ],
        pkname: [
          {required: true, message: "请输入充电桩名称", trigger: "blur"},
        ],
        portCount: [
          {required: true, message: "请输入端口数量", trigger: "blur"},
          {validator: validateNum, trigger: "blur"},
        ],
        // simCard: [{required: true, message: "请输入卡序号", trigger: "blur"}],
        // simDueTime: [
        //   {required: true, message: "请选择到期时间", trigger: "blur"},
        // ],
        pileType: [
          {required: true, message: "请选择充电桩类型", trigger: "blur"},
        ],
        pileStatus: [
          {required: true, message: "请选择状态", trigger: "blur"},
        ],
        userId: [{required: true, message: "请选择代理商", trigger: "blur"}],
        plot: [{required: true, message: "请选择站点", trigger: "blur"}],
      },
      xiaoquName: "",
      typeName: "",
      stateName: "",
      showPicker: false,
      dataType: "",
      simDateVisible: false,
      simDueTime: "",
      detectionId: false,
      editMode: false,
    };
  },
  async mounted() {
    await this.getOperatorSelect();
    this.isAdmin = JSON.parse(localStorage.adminuser).adminuser.admin === "Y";
    this.getPlotList({pageNo: 1, pageSize: 999});
    if (this.$route.query.id) {
      this.editMode = true;
      this.formData = this.$route.query;
      this.formData.oldId = this.$route.query.id;
      this.userName =
          this.operatorList[0].find((val) => val.label == this.formData.userId) &&
          this.operatorList[0].find((val) => val.label == this.formData.userId)
              .value;
      // this.stateName = this.stateList[0][this.$route.query.pileStatus].value;
      // this.typeName = this.typeList[0][this.$route.query.pileType].value;
      this.xiaoquName = this.formData.plotName;
      this.simDueTime = this.formData.simDueTime;
      delete this.formData.plotName;
      document.title = "设备编辑";
    }
  },
  methods: {
    async getOperatorSelect() {
      const res = await getOperatorSelect();
      this.operatorList = [
        res.data.map((item) => {
          return {
            label: item.operatorId,
            value: item.operatorNm,
          };
        }),
      ];
    },
    SelectOperator() {
      this.showOperatorSelect = true;
    },
    closePicker() {
      this.showOperatorSelect = false;
    },
    confirmPicker(even) {
      this.userName = even[0].value;
      this.formData.userId = even[0].label;
      this.showOperatorSelect = false;
    },
    detectionIdFun() {
      getEquipList({
        keyWord: this.formData.id,
        pageNo: 1,
        pageSize: 10,
        deviceType: 4,
      }).then((res) => {
        if (res.data.records.length === 0) {
          return;
        }
        if (this.formData.id == res.data.records[0].id) {
          this.detectionId = true;
        } else {
          this.detectionId = false;
        }
      });
    },
    onCancel() {
      this.$router.replace({
        path: "/admin/equip",
      });
    },
    switchPicker(date) {
      this.simDateVisible = false;
    },
    onSubmit() {
      this.$refs.form.validate((valid, validObject) => {
        if (valid) {
          if (this.xiaoquName == "") {
            Toast("请选择站点");
            return;
          }
          if (this.$route.query.id) {
            editPile(this.formData)
                .then((res) => {
                  if (res.message.code == 0) {
                    Toast("保存成功");
                    this.$router.replace({
                      path: "/admin/equip",
                    });
                  } else {
                    Toast(res.message.message);
                  }
                })
                .catch((e) => {
                  Toast("接口异常");
                });
          } else {
            addEquip(this.formData)
                .then((res) => {
                  if (res.message.code == 0) {
                    Toast("保存成功");
                    this.$router.replace({
                      path: "/admin/equip",
                    });
                  } else {
                    Toast(res.message.message);
                  }
                })
                .catch((res) => {
                  Toast("接口异常");
                });
          }
        } else {
          let toastMeg = Object.keys(validObject).map(key => {
            return validObject[key][0].message
          })
          console.log(toastMeg)
          Toast(toastMeg[0]);
        }
      });
    },
    getPlotList(PlotForm) {
      getPlotList(PlotForm).then((res) => {
        this.plotList = [
          res.data.records.map((item) => {
            return {
              label: item.id,
              value: item.plotName,
            };
          }),
        ];
      });
    },
    Select(dataType) {
      this.dataType = dataType;
      switch (dataType) {
        case "plot":
          this.activeList = this.plotList;
          this.showPicker = true;
          break;
        case "type":
          this.activeList = this.typeList;
          this.showPicker = true;
          break;
        case "state":
          this.activeList = this.stateList;
          this.showPicker = true;
          break;
        case "date":
          this.simDateVisible = true;
          break;
        default:
          break;
      }
    },
    closeSwitch() {
      this.showPicker = false;
    },
    confirm(even) {
      switch (this.dataType) {
        case "plot":
          this.xiaoquName = even[0].value;
          this.formData.plot = even[0].label;
          break;
        case "type":
          this.typeName = even[0].value;
          this.formData.pileType = even[0].label;
          break;
        case "state":
          this.stateName = even[0].value;
          this.formData.pileStatus = even[0].label;
          break;
        default:
          break;
      }
      this.showPicker = false;
    },
    dateConfirm(even) {
      this.simDueTime = even.splice(5, 1).join(",");
      this.formData.simDueTime = this.simDueTime;
      this.simDateVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/sass/state.scss";

.equipaddMain {

  .form-content {
    margin-bottom: 0.3rem;

    ::v-deep .el-form {
      .el-form-item {
        margin-bottom: 0;

        &:last-child {
          border-bottom: 0 !important;
        }
      }
    }

    ::v-deep .el-form-item__label {
      width: 2.5rem;
      text-align: left;
      padding-right: 0;
    }

    .sim-due-time {
      ::v-deep .el-form-item__label {
        width: 2.7rem !important;
      }
    }

    .radio-group {
      ::v-deep .el-radio-group {
        flex: 1;

        .el-radio {
          &:first-child {
            margin-right: 1rem;

          }
        }
      }

      ::v-deep .el-form-item__content {
        padding-left: 0.3rem;
        display: flex;
      }

      ::v-deep .el-radio__inner,
      ::v-deep .el-checkbox__inner {
        width: 0.4864rem;
        height: 0.4864rem;
      }

      ::v-deep .is-checked .el-radio__inner::after {
        width: 0.1864rem !important;
        height: 0.1864rem !important;

      }

      ::v-deep .is-checked .el-checkbox__inner::after {
        width: 0.121rem !important;
        height: 0.1891rem !important;
        font-weight: bold;
        margin-top: 0.02rem;
        margin-left: 0.02rem;
        border-width: 2px !important;
      }

      ::v-deep .el-radio__label,
      ::v-deep .el-checkbox__label {
        padding: 0.2rem !important;
        color: #999999;
      }
    }

  }

}
</style>
